import React from "react";
import _ from "lodash";
import Fuse from "fuse.js";
import numeral from "numeral";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";

import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import Checkbox from "@material-ui/core/Checkbox";
import Card from "@material-ui/core/Card";

import { filterProjectsByQuery } from "../../screens/MapScreen/utils";
import { getDistance } from "../../utils/map-utils";
import {
  getProjectStat,
  calculateAvgProjectStats,
} from "../../utils/stat-utils";
import { getColorByScoreType, getStationColor } from "../../utils/color-utils";
import { calculateFacilityScore } from "../../utils/facilities-utils";
import { checkRole } from "../../utils/checkRole";
import { withStyles } from "@material-ui/core/styles";

const fuseOptions = {
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["title.en", "title.th"],
};

const DenseTableCell = withStyles({
  root: {
    paddingLeft: 6,
    paddingRight: 6,
  },
})(TableCell);

const getProjectWithinRadius = (projects, { lat, lng }, inner, outer) => {
  return _.filter(projects, (p) => {
    // console.log('p', p);
    const projectLat = _.get(p, "location.position._lat");
    const projectLng = _.get(p, "location.position._long");
    const d = getDistance(projectLat, projectLng, lat, lng);
    // console.log(projectLat, projectLng, lat, lng, d);
    return d <= 0.001 * outer && d >= 0.001 * inner;
  });
};

const sanitizeKeyValues = (key, values) => {
  return _.map(
    _.filter(values, (value) => {
      // console.log('sanitizeKeyValues', key, value, value[key])
      if (value[key] === "N/A") return false;
      if (value[key] === 0) return false;
      if (_.isNaN(value[key])) return false;
      if (value[key] === Infinity) return false;
      return true;
    }),
    key
  );
};

const getProjectsStats = (projects) => {
  if (_.size(projects) === 0) {
    return {
      salePrice: 0,
      capitalGain: 0,
      startingPrice: 0,
      rentalPrice: 0,
      rentalYield: 0,
    };
  }

  const allProjectStats = _.map(projects, getProjectStat);
  const avgStats = calculateAvgProjectStats(allProjectStats);

  return avgStats;

  // const textAvg = {
  //   salePrice: _.size(salePriceValues) === 0 ? 'N/A' : `${numeral(avg.salePrice).format("0,0a")}`,
  //   capitalGain: _.size(capitalGainValues) === 0 ? 'N/A' : numeral(avg.capitalGain).format("0.00%"),
  //   startingPrice: _.size(startingPriceValues) === 0 ? 'N/A' : `${numeral(avg.startingPrice).format("0.00a")}`,
  //   rentalPrice: _.size(rentalPriceValues) === 0 ? 'N/A' : `${numeral(avg.rentalPrice).format("0,0.00")}`,
  //   rentalYield: _.size(rentalYieldValues) === 0 ? 'N/A' : numeral(avg.rentalYield).format("0.00%"),
  // }

  // const capitalGainValues = _.compact(_.map(allProjectStats, stat => stat.capitalGain));
  // const rentalPriceValues = _.compact(_.map(allProjectStats, stat => stat.rentalPrice));
  // const rentalYieldValues = _.compact(_.map(allProjectStats, stat => stat.rentalYield));
  // const salePriceValues = _.compact(_.map(allProjectStats, stat => stat.salePrice));
  // const startingPriceValues = _.compact(_.map(allProjectStats, stat => stat.startingPrice));

  // return {
  //   salePrice: _.sum(salePriceValues) / _.size(salePriceValues),
  //   capitalGain: _.sum(capitalGainValues) / _.size(capitalGainValues),
  //   startingPrice: _.sum(startingPriceValues) / _.size(startingPriceValues),
  //   rentalPrice: _.sum(rentalPriceValues) / _.size(rentalPriceValues),
  //   rentalYield: _.sum(rentalYieldValues) / _.size(rentalYieldValues)
  // };
};

const StyledTableRow = withStyles({
  root: {
    cursor: "pointer",
    "&$selected": {
      backgroundColor: "#f00",
    },
  },
})(TableRow);

const StationTableRow = connect(
  (state, ownProps) => ({
    hilight: _.includes(
      _.get(state, "domain.map.analysisHilightStations"),
      ownProps.id
    ),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        toggleSelectStation: (stationId) => ({
          type: "DOMAIN/MAP/ANALYSIS/HILIGHT_STATION/TOGGLE",
          stationId,
        }),
        selectStation: (stationId) => ({
          type: "DOMAIN/MAP/ANALYSIS/HILIGHT_STATION/SELECT",
          stationId,
        }),
        unselectStation: (stationId) => ({
          type: "DOMAIN/MAP/ANALYSIS/HILIGHT_STATION/UNSELECT",
          stationId,
        }),
      },
      dispatch
    )
)(
  class extends React.PureComponent {
    handleClick = (e) => {
      const { id, toggleSelectStation } = this.props;
      toggleSelectStation(id);
    };
    render() {
      const { id, title, stats, keys, minmax, hilight } = this.props;
      return (
        <StyledTableRow
          key={id}
          hover
          selected={hilight}
          onClick={this.handleClick}
          // onMouseOver={e => onHover(id)}
        >
          <TableCell>
            <Avatar
              style={{
                fontFamily: "Arial",
                fontSize: "0.9em",
                fontWeight: "bold",
                width: 40,
                height: 40,
                backgroundColor: getStationColor(id),
              }}
            >
              {_.replace(id, /(BTS.|MRT.)/, "")}
            </Avatar>
          </TableCell>
          <TableCell>{_.get(title, "en", "")}</TableCell>
          {_.map(keys, (keyObj, key) => {
            const { prefix, format, suffix } = keyObj;
            const value = _.get(stats, key);
            const displayValue =
              value === "N/A"
                ? "N/A"
                : `${prefix}${numeral(value).format(format)}${suffix || ""}`;
            return (
              <DenseTableCell
                style={{
                  color: getColorByScoreType(
                    value,
                    _.get(minmax, `${key}.min`),
                    _.get(minmax, `${key}.max`),
                    key
                  ),
                }}
              >
                {displayValue}
              </DenseTableCell>
            );
          })}
        </StyledTableRow>
      );
    }
  }
);

const mapStateToProps = (state, ownProps) => {
  const mapReducer = _.get(state, "domain.map");
  // const analysisReducer = _.get(state, 'domain.analysis');
  const { query } = mapReducer;
  const radius = mapReducer.analysisStationRadius || 600;

  const viewOptionList = _.get(state, "domain.analysis.viewOptionList", []);

  const blackListStations = [
    "BTS.N15",
    "BTS.E20",
    "BTS.E19",
    "BTS.E18",
    "MRT.BL01",
  ];
  const selectedPublicTransportLines = _.get(
    state,
    "domain.analysis.viewOptionsLines",
    []
  );

  const stations = _.filter(
    _.get(state, "entities.pointOfInterests.entities"),
    (poi) => _.includes(["BTS", "MRT"], poi.type)
  );
  const visibleStations = stations;
  // const visibleStations = _.filter(
  //   stations,
  //   (st) =>
  //     _.size(_.intersection(st.lines, selectedPublicTransportLines)) > 0 &&
  //     !_.includes(blackListStations, st.id)
  // );

  const projectsObject = {};
  const fullProjectsObject = _.get(state, "newProjects.fullProjects");
  _.map(fullProjectsObject, (project, i) => {
    projectsObject[_.get(project, "id")] = {
      ...project,
      rooms: _.get(project, "fullRooms"),
    };
  });
  const projectEntities = projectsObject;
  const filteredProjects = filterProjectsByQuery(projectEntities, query);

  // const allFacilities = _.get(state, 'entities.facilities.entities');

  const stationsWithProjects = _.chain(visibleStations)
    .take(100)
    .map((station) => {
      const lat = _.get(station, "location.position._lat");
      const lng = _.get(station, "location.position._long");
      const projectsNearStation = getProjectWithinRadius(
        filteredProjects,
        { lat, lng },
        0,
        radius
      );
      // console.log('projectsNearStation', projectsNearStation);
      // const facilityScores = calculateFacilityScore(allFacilities, lat, lng);

      const stationStats = getProjectsStats(projectsNearStation);

      return {
        ...station,
        projects: projectsNearStation,
        stats: {
          ...stationStats,
          // facilityScore: _.sumBy(facilityScores, score => score.value) / _.size(facilityScores),
        },
        radius,
      };
    })
    .filter((station) => _.size(station.projects) > 0)
    .value();

  return {
    stations: stationsWithProjects,
    viewOptions: viewOptionList,
  };
};

export default connect(mapStateToProps)(
  class extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
      return {
        checked: nextProps.viewOptions,
      };
    }
    state = {
      search: "",
      orderBy: "percentSold",
      order: "desc",
      checked: [],
      open: false,
    };

    fuse = null;

    componentDidMount = () => {
      this.fuse = new Fuse(this.props.stations, fuseOptions);
    };

    shouldComponentUpdate = (nextProps, nextState) => {
      return (
        !_.isEqual(nextProps, this.props) || !_.isEqual(nextState, this.state)
      );
    };

    componentDidUpdate = (prevProps) => {
      if (!_.isEqual(prevProps.stations, this.props.stations)) {
        this.fuse = new Fuse(this.props.stations, fuseOptions);
      }
    };

    createSortHandler = (property) => (event) => {
      if (this.state.orderBy === property) {
        this.setState({ order: this.state.order === "desc" ? "asc" : "desc" });
      } else {
        this.setState({
          orderBy: property,
          order: "desc",
        });
      }
    };
    handleChangeSearch = (e) => this.setState({ search: e.target.value });
    // handleSelectStation = (stationId) => {
    //   const { dispatch } = this.props;
    //   console.log('stationId', stationId);
    //   dispatch({ type: 'DOMAIN/MAP/ANALYSIS/HILIGHT_STATION/CHANGE', stationId });
    // }

    // handleClearSelectStation = (e) => {
    //   const { dispatch } = this.props;
    //   dispatch({ type: 'DOMAIN/MAP/ANALYSIS/HILIGHT_STATION/CLEAR' });
    // }

    handleToggle = (value) => () => {
      const { dispatch } = this.props;
      const { checked } = this.state;
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      this.setState({
        checked: newChecked,
      });

      dispatch({
        type: "DOMAIN/ANALYSIS/VIEWOPTION/CHANGE",
        values: newChecked,
      });
    };

    handleClick = () => {
      this.setState({ open: !this.state.open });
    };

    orderStat = (filterData, key) => {
      const filterNA = _.filter(
        filterData,
        (item) => _.get(item.stats, key) !== "N/A"
      );
      const removeNA = _.filter(
        filterData,
        (item) => _.get(item.stats, key) === "N/A"
      );

      const orderData = _.orderBy(
        filterNA,
        (item) => _.get(item.stats, key),
        this.state.order
      );
      const concatData = _.concat(orderData, removeNA);

      return concatData;
    };

    render() {
      const { stations, viewOptionList, userRoles } = this.props;
      const { search, order, orderBy, checked } = this.state;
      const minmax = _.reduce(
        stations,
        (acc, station) => {
          _.forIn(station.stats, (value, key) => {
            if (value < _.get(acc, `${key}.min`, 99999999))
              _.set(acc, `${key}.min`, value);
            if (value > _.get(acc, `${key}.max`, 0))
              _.set(acc, `${key}.max`, value);
          });
          return acc;
        },
        {}
      );
      console.warn("Summary::Analysis", minmax);
      //
      // const keys = {
      //   salePrice: { label: 'Sale Price', prefix: '', format: '0,0a' },
      //   capitalGain: { label: 'Capital Gain', prefix: '', format: '0.00%' },
      //   startingPrice: { label: 'Starting Price', prefix: '', format: '0,0a' },
      //   rentalPrice: { label: 'Rent Price', prefix: '', format: '0,0.00' },
      //   rentalYield: { label: 'Rental Yield', prefix: '', format: '0.00%' },
      //   facilityScore: { label: 'Facility Score', prefix: '', format: '0.00%' },
      // };
      let keys = {};
      _.map(checked, (c) => {
        switch (c) {
          case "percentSold":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.percentSold = {
                label: "% Sold",
                prefix: "",
                suffix: "%",
              };
            }
            break;
          case "unitsLeft":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.unitsLeft = {
                label: "Units Left",
                prefix: "",
                format: "0",
              };
            }

            break;
          case "absorptionRateAll":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.absorptionRateAll = {
                label: "Absorption Rate / Quarter",
                prefix: "",
                format: "0.00%",
              };
            }

            break;
          case "absorptionRateLastQ":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.absorptionRateLastQ = {
                label: "Absorption Rate Last Quarter",
                prefix: "",
                format: "0.00%",
              };
            }

            break;
          case "estimateTimeToDairn":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.estimateTimeToDairn = {
                label: "Estimate Time to Dairn ( Month )",
                prefix: "",
                format: "0.00",
              };
            }

            break;
          case "startingResalePrice":
            keys.startingResalePrice = {
              label: "Avg. Resale Package (For Sale)",
              prefix: "",
              format: "0.00a",
            };
            break;
          case "resalePriceSqm":
            keys.resalePriceSqm = {
              label: "Avg. Resale Price /sq.m. (For Sale)",
              prefix: "",
              format: "0.00a",
            };
            break;
          case "rentalPrice":
            keys.rentalPrice = {
              label: "Avg. Rental Package (For Rent)",
              prefix: "",
              format: "0.00a",
            };
            break;
          case "rentalPriceSqm":
            keys.rentalPriceSqm = {
              label: "Avg. Rental Price /sq.m. (For Rent)",
              prefix: "",
              format: "0.00a",
            };
            break;
          case "capitalGain":
            keys.capitalGain = {
              label: "Cap. Gain",
              prefix: "",
              format: "0.00a",
            };
            break;
          case "rentalYield":
            keys.rentalYield = {
              label: "Rental Yield",
              prefix: "",
              suffix: "%",
            };
            break;
          case "launchPriceSqm":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.launchPriceSqm = {
                label: "Average of Launch Price",
                prefix: "",
                format: "0.00a",
              };
            }
            break;
          case "startingPrice":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.startingPrice = {
                label: "Starting Package (Project)",
                prefix: "",
                format: "0.00a",
              };
            }
            break;
          case "startingCurrentPrice":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.startingCurrentPrice = {
                label: "Starting Current Package (Project)",
                prefix: "",
                format: "0.00a",
                suffix: "m",
              };
            }
            break;
          case "currentPriceSqm":
            if (!checkRole(userRoles, "mi-treasure.general-member")) {
              keys.currentPriceSqm = {
                label: "Current Price / sq.m.",
                prefix: "",
                format: "0.00a",
              };
            }

            break;
          default:
            break;
        }
      });

      const filteredStations =
        search !== "" && !_.isEmpty(this.fuse)
          ? this.fuse.search(search)
          : stations;

      const orderedStations = this.orderStat(
        filteredStations,
        this.state.orderBy
      );
      // const orderedStations = _.orderBy(
      //   filteredStations,
      //   [`stats.${this.state.orderBy}`],
      //   [this.state.order]
      // );

      const AnalysisContainer = styled.div`
        width: 30vw;
        padding-top: 80px;
        /* overflow: auto; */

        @media only screen and (max-width: 959px) {
          width: 100vw;
        }
      `;

      let columnCheckboxes = [
        // { value: 'projectStatus', label: 'Project Status' },
        // { value: 'contructionStatus', label: 'Contruction Status' },
        { value: "marketPrice", label: "Market Price", type: "header" },
        {
          value: "startingResalePrice",
          label: "Avg. Resale Package (For Sale)",
        },
        {
          value: "resalePriceSqm",
          label: "Avg. Resale Price /sq.m. (For Sale)",
        },
        { value: "rentalPrice", label: "Avg. Rental Package (For Rent)" },
        {
          value: "rentalPriceSqm",
          label: "Avg. Rental Price /sq.m. (For Rent)",
        },
        { value: "capitalGain", label: "Cap. Gain" },
        { value: "rentalYield", label: "Rental Yield" },

        // { value: 'facilityScore', label: 'Facility Score' },
      ];

      if (!checkRole(userRoles, "mi-treasure.general-member")) {
        columnCheckboxes.unshift({
          value: "estimateTimeToDairn",
          label: "Esimate Time to Dairn ( Month )",
        });
        columnCheckboxes.unshift({
          value: "absorptionRateLastQ",
          label: "Absorption Rate Last Quarter",
        });
        columnCheckboxes.unshift({
          value: "absorptionRateAll",
          label: "Absorption Rate / Quarter",
        });
        columnCheckboxes.unshift({ value: "unitsLeft", label: "Units Left" });
        columnCheckboxes.unshift({ value: "percentSold", label: "% Sold" });
        columnCheckboxes.unshift({
          value: "projectStatus",
          label: "Project Status",
          type: "header",
        });

        columnCheckboxes.push({
          value: "projectPrice",
          label: "Project Price",
          type: "header",
        });
        columnCheckboxes.push({
          value: "launchPriceSqm",
          label: "Average of Launch Price",
        });
        columnCheckboxes.push({
          value: "startingPrice",
          label: "Starting Package (Project)",
        });
        columnCheckboxes.push({
          value: "startingCurrentPrice",
          label: "Starting Current Package (Project)",
        });
        columnCheckboxes.push({
          value: "currentPriceSqm",
          label: "Current Price / sq.m.",
        });
      }

      return (
        <AnalysisContainer>
          <Card
            elevetaion={2}
            style={{
              position: "absolute",
              top: "22px",
              left: "44px",
              width: "200px",
              zIndex: 9,
            }}
          >
            <div>
              <List dense disablePadding>
                <ListItem
                  button
                  style={{ background: "#f7f7f7" }}
                  onClick={this.handleClick}
                >
                  <ListItemText primary="View Option" />
                  {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    disablePadding
                    dense
                    style={{
                      background: "#f7f7f7",
                      height: "60vh",
                      overflowY: "auto",
                    }}
                  >
                    {columnCheckboxes.map((item) => {
                      if (_.get(item, "type") === "header") {
                        return (
                          <ListItem
                            button
                            key={item.value}
                            style={{
                              paddingTop: 8,
                              paddingBottom: 8,
                              paddingLeft: 24,
                            }}
                          >
                            <ListItemText
                              disableTypography
                              primary={item.label}
                              style={{
                                fontSize: 12,
                                fontFamily: "SukhumvitSet-Bold",
                                lineHeight: "1.5em",
                                paddingLeft: 8,
                              }}
                            />
                          </ListItem>
                        );
                      } else {
                        return (
                          <ListItem
                            button
                            key={item.value}
                            style={{
                              paddingTop: 8,
                              paddingBottom: 8,
                              paddingLeft: 24,
                            }}
                            onClick={this.handleToggle(item.value)}
                          >
                            <Checkbox
                              checked={checked.indexOf(item.value) !== -1}
                              tabIndex={-1}
                              disableRipple
                            />
                            <ListItemText
                              primary={item.label}
                              style={{ fontSize: 12, paddingLeft: 8 }}
                            />
                          </ListItem>
                        );
                      }
                    })}
                  </List>
                </Collapse>
              </List>
            </div>
          </Card>

          <Grid container>
            <Grid item sm={6}></Grid>
            <Grid item sm={6} style={{ textAlign: "right" }}>
              <TextField
                variant="outlined"
                placeholder="Search"
                onChange={this.handleChangeSearch}
                margin="dense"
              />
            </Grid>
          </Grid>
          <Table
            padding="dense"
            style={{
              fontSize: "0.8em",
              height: "calc(100vh - 300px)",
              display: "block",
              overflow: "auto",
              marginTop: 15,
            }}
            __onMouseOut={this.handleClearSelectStation}
          >
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Title</TableCell>
                {_.map(keys, (row, id) => {
                  return (
                    <DenseTableCell
                      key={id}
                      aligh={row.numeric ? "right" : "left"}
                      padding={row.disablePadding ? "none" : "default"}
                      sortDirection={orderBy === id ? order : false}
                    >
                      <Tooltip
                        title={`Sort by ${row.label}`}
                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                        enterDelay={300}
                      >
                        <TableSortLabel
                          active={orderBy === id}
                          direction={order}
                          onClick={this.createSortHandler(id)}
                        >
                          {row.label}
                        </TableSortLabel>
                      </Tooltip>
                    </DenseTableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {_.map(orderedStations, (station) => {
                // console.log('nong station', station);
                return (
                  <StationTableRow {...station} keys={keys} minmax={minmax} />
                );
              })}
            </TableBody>
          </Table>
        </AnalysisContainer>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/SummaryContainer/Analysis.js